import type { TextFormatTransformer } from '@lexical/markdown'

export const UNDERLINE: TextFormatTransformer = {
  format: ['underline'],
  tag: '``',
  type: 'text-format',
}
